import * as React from 'react';
import {observer} from 'mobx-react';
import {PageHeader} from './page-header';
import {px} from 'csx';
import {mediaTablet} from '../theme/media';
import {style} from 'typestyle';
import {LoadingContainer} from './loading-container';
import {PageFAQSection} from './page-faq-section';

const PrismicDOM = require('prismic-dom');

export interface PageFAQModel {
  loading: boolean;
  page_title: any;
  page_body: any;
  cover_image: string;
  sections: any[];
}

export interface PageFAQProps {
  model: PageFAQModel;
}

export const PageFAQ = observer<PageFAQProps>(
  ({ model }) => (
    <LoadingContainer loading={model.loading}>
      <PageHeader
        coverImage={model.cover_image}
        dangerouslySetInnerHTML={{ __html: model.loading ? null : PrismicDOM.RichText.asHtml(model.page_title) }}
      />
      <div className={styles.content}>
        {!model.loading && model.sections.map((section, index) => (
          <PageFAQSection key={index.toString()} section={section} />
        ))}
      </div>
    </LoadingContainer>
  )
);

const styles = {
  content: style({
    padding: px(20),
    ...mediaTablet({ padding: px(80) })
  })
};